import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { useFixBody } from "@state/hooks/shared";

import BettingTipsPopupHeader from "./components/popups/BettingTipsPopupHeader";
import BettingTipsPopupFooter from "./components/popups/BettingTipsPopupFooter";
import BettingTipsPopupBody from "./components/popups/BettingTipsPopupBody";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";
import { createPortal } from "react-dom";

export default observer(function BettingTipsPopup(props: {
	bettingTipsStore: BettingTipsStore;
	isEventLinkDisabled?: boolean;
}) {
	const popupElement = useRef<null | HTMLDivElement>(null);

	useFixBody(true, props.bettingTipsStore.isPopupDisplayed);

	useEffect(() => {
		popupElement.current?.scrollTo({ top: 0 });
	}, [props.bettingTipsStore.isPopupDisplayed]);

	if (!props.bettingTipsStore.selectedTip) {
		return null;
	}

	return createPortal(
		<div className="popup popup--full">
			<div className="popup__card popup--most__card">
				<BettingTipsPopupHeader store={props.bettingTipsStore} />
				<div className="popup__body" ref={popupElement}>
					<BettingTipsPopupBody
						key={props.bettingTipsStore.selectedTip?.id}
						tip={props.bettingTipsStore.selectedTip}
						isEventLinkDisabled={props.isEventLinkDisabled}
					/>
				</div>
				<BettingTipsPopupFooter
					store={props.bettingTipsStore}
					tip={props.bettingTipsStore.selectedTip}
				/>
			</div>
		</div>,
		document.getElementById("app-modal") || document.body
	);
});
